import TelecomOffersTable from '../../OffersList/Telecom/TelecomOffersTable'
import ProviderShow from '../ProviderShow'

const TelecomShow = () => <ProviderShow OffersTableComponent={TelecomOffersTable} />

export default TelecomShow
